module.exports = __webpack_public_path__ + "static/logo-7ef0f5eea73143e477b79678a35be894.png";